import { createFileRoute } from '@tanstack/react-router';

import { OrganizationDetailPage } from '../modules/organizations/ui/pages/OrganizationDetailPage';

export const Route = createFileRoute('/_authenticated/super-admin/organizations/$orgId')({
  component: OrganizationDetailPage,
  staticData: {
    breadcrumb: ['Platform', 'Organizations', 'Detail'],
  },
});
